import { Provider } from '@angular/core';
import { COLLECTIVE_DOCUMENT_LIST_COMPONENT_LOADER } from '../components/widget-generic-document-list/widget-generic-document-list.component';

export const COLLECTIVE_DOCUMENT_DIALOG_PROVIDERS: Provider[] = [
  {
    provide: COLLECTIVE_DOCUMENT_LIST_COMPONENT_LOADER,
    useValue: () =>
      import('../components/collective-document-list-widget/collective-document-list-widget.component')
        .then(m => m.CollectiveDocumentListWidgetComponent),
  },
];
